export default __webpack_public_path__ + "static/media/face-1.13a31bf5.jpg";